import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


export function ShowToast(
  clientMessage = "نتیجه درخواست",
  type = ToastType.default,
  timer = 5000,
  toastPosition = "bottom-left",
) {

  switch (type) {
    case ToastType.default:
      toast.default(clientMessage, {
        position: toastPosition,
        autoClose: timer,
      });
      break;
    case ToastType.success:
      toast.success(clientMessage, {
        position: toastPosition,
        autoClose: timer,
      });
      break;
    case ToastType.info:
      toast.info(clientMessage, {
        position: toastPosition,
        autoClose: timer,
      });
      break;
    case ToastType.error:
      toast.error(clientMessage, {
        position: toastPosition,
        autoClose: timer,
      });
      break;
    case ToastType.warning:
      toast.warning(clientMessage, {
        position: toastPosition,
        autoClose: timer,
      });
      break;
    case ToastType.dark:
      toast.dark(clientMessage, {
        position: toastPosition,
        autoClose: timer,
      });
      break;

    default:
      break;
  }
};

export const ToastType = Object.freeze({
  default: 1,
  success: 2,
  info: 3,
  error: 4,
  warning: 5,
  dark: 6,
});

